import { NetworkTypes } from 'Interfaces/NetworkTypes';

export const ifaceKvp:NetworkTypes = {
  wlan0: 'Wi-Fi',
  wwan0: 'LTE',
  eth0: 'Ethernet',
  eth1: 'Ethernet'
};
